enum LingoLiftSummaryStatus {
  NotStarted = 'Not Started',
  Started = 'Started',
  Completed = 'Completed',
}

export { LingoLiftSummaryStatus };
